import React from "react"
import { useFider } from "@fider/hooks"

interface BronzeDrumProps {
  className?: string
}

// Tùy biến KHCN: mặt trống đồng Đông Sơn (ảnh nét vẽ trong static/hero/trong-dong.png, nền trong suốt).
// Gồm quầng sáng vàng phía sau, mặt trống xoay chậm và một vành sáng mảnh xoay ngược để tạo chiều sâu.
// Chuyển động ở HeroBanner.scss, tự tắt khi prefers-reduced-motion.
export const BronzeDrum = ({ className }: BronzeDrumProps) => {
  const fider = useFider()
  return (
    <div className={`kh-drum ${className || ""}`} aria-hidden="true">
      <span className="kh-drum__halo" />
      <span className="kh-drum__ring" />
      <img className="kh-drum__face" src={`${fider.settings.assetsURL}/static/assets/hero/trong-dong.png`} alt="" width={500} height={500} draggable={false} />
    </div>
  )
}
